import React from "react";

const VARIANTS = {
  success: "bg-success-50 text-success-700",
  warning: "bg-warning-50 text-warning-700",
  danger:  "bg-danger-50 text-danger-700",
  info:    "bg-info-50 text-info-700",
  brand:   "bg-brand-50 text-brand-700",
  neutral: "bg-gray-100 text-content-secondary",
};

const Badge = ({ children, variant = "neutral", dot = false, className = "" }) => {
  return (
    <span
      className={`
        inline-flex items-center gap-1.5 px-2.5 py-0.5
        rounded-badge text-caption font-medium
        ${VARIANTS[variant] || VARIANTS.neutral}
        ${className}
      `.trim()}
    >
      {dot && (
        <span className="w-1.5 h-1.5 rounded-full bg-current flex-shrink-0" />
      )}
      {children}
    </span>
  );
};

export default Badge;
